export default class Timing {

	constructor(easing, duration, delay) {
		this.easing = easing;
		this.duration = duration;
		this.delay = (typeof delay === 'number') ? delay : 0;
		this.l = 0; // Linear [0-1]
		this.t = 0; // With easing [0-1]
		this.init = false;
	}

	reset() {
		this.l = 0;
		this.t = 0;
		this.init = false;
	}

	increase(timestamp) {
		if (this.l === 1) {
			return false;
		}
		if (this.init === false) {
			this.init = timestamp;
		}
		let l = (timestamp - (this.init + this.delay)) / this.duration;
		l = Math.max(Math.min(l, 1), 0);
		this.t = this.ease(l);
		return true;
	}

	ease(l) {
		if (this.easing === 'easeInQuad') {
			return l * l; // Accelerating from zero velocity
		} else if (this.easing === 'easeOutQuad') {
			return l * (2 - l); // Decelerating to zero velocity
		} else if (this.easing === 'easeInOutQuad') {
			return l < 0.5 ? 2 * l * l : -1 + (4 - 2 * l) * l; // Acceleration until halfway, then deceleration
		} else if (this.easing === 'easeInCubic') {
			return l * l * l; // Accelerating from zero velocity
		} else if (this.easing === 'easeOutCubic') {
			return (--l) * l * l + 1; // Decelerating to zero velocity
		} else if (this.easing === 'easeInOutCubic') {
			return l < 0.5 ? 4 * l * l * l : (l - 1) * (2 * l - 2) * (2 * l - 2) + 1; // Acceleration until halfway, then deceleration
		} else if (this.easing === 'easeInQuart') {
			return l * l * l * l; // Accelerating from zero velocity
		} else if (this.easing === 'easeOutQuart') {
			return 1 - (--l) * l * l * l; // Decelerating to zero velocity
		} else if (this.easing === 'easeInOutQuart') {
			return l < 0.5 ? 8 * l * l * l * l : 1 - 8 * (--l) * l * l * l; // Acceleration until halfway, then deceleration
		} else if (this.easing === 'easeInQuint') {
			return l * l * l * l * l; // Accelerating from zero velocity
		} else if (this.easing === 'easeOutQuint') {
			return 1 + (--l) * l * l * l * l; // Decelerating to zero velocity
		} else if (this.easing === 'easeInOutQuint') {
			return l < 0.5 ? 16 * l * l * l * l * l : 1 + 16 * (--l) * l * l * l * l; // Acceleration until halfway, then deceleration
		} else {
			return l;
		}
	}

}
